// // src/App.js
// import React from "react";
// import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import MainLayout from "./components/Layout/MainLayout";
// import Dashboard from "./pages/Dashboard/Dashboard";
// import ExpressWayMap from "./components/Map/ExpressWayMap";
// import EventLog from "./pages/EventLog/EventLog";
// import RSUManagement from "./pages/RSUManagement/RSUManagement"; 
// import OBUManagement from "./pages/OBUManagement/OBUManagement"; 

// // import DrivingSimulation from "./pages/DrivingSimulation/DrivingSimulation";

// function App() {
 
//   return (
//     <BrowserRouter>
//       <MainLayout>     
//         <Routes>
//           <Route path="/" element={<Navigate to="/dashboard" replace />} />
//           <Route path="/dashboard" element={<Dashboard />} />
//           <Route path="/map" element={<ExpressWayMap />} />
//           <Route path="/rsu" element={<RSUManagement />} />
//           <Route path="/obu" element={<OBUManagement />} />
//           <Route path="/event" element={<EventLog />} />
//           {/* <Route path="/simulation" element={<DrivingSimulation />} /> */}
//         </Routes>
//       </MainLayout>
//     </BrowserRouter>
//   );
// }

// export default App;

// src/App.js
import React, { useState, useEffect } from "react";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./components/Layout/MainLayout";
import Dashboard from "./pages/Dashboard/Dashboard";
import ExpressWayMap from "./components/Map/ExpressWayMap";
import EventLog from "./pages/EventLog/EventLog";
import RSUManagement from "./pages/RSUManagement/RSUManagement"; 
import OBUManagement from "./pages/OBUManagement/OBUManagement"; 
import LoginPage from "./pages/Login/LoginPage";

// ฟังก์ชันช่วยเช็คว่า Session ยังดีอยู่ไหม
const isSessionValid = () => {
  const sessionStr = localStorage.getItem("v2x_session");
  if (!sessionStr) return false;

  const session = JSON.parse(sessionStr);
  const now = new Date().getTime();

  // ถ้าเวลาปัจจุบัน เกินเวลาที่กำหนดไว้ แสดงว่าหมดอายุ
  if (now > session.expiry) {
    localStorage.removeItem("v2x_session"); // ลบขยะทิ้ง
    return false;
  }
  return true;
};

const ProtectedRoute = ({ isAuthenticated, children }) => {
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  // เริ่มต้นเช็คทันทีที่เปิดแอป
  const [isAuthenticated, setIsAuthenticated] = useState(isSessionValid());

  // ฟังก์ชัน Login: อัปเดต State
  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  // ฟังก์ชัน Logout: ลบ Session และอัปเดต State
  const handleLogout = () => {
    localStorage.removeItem("v2x_session");
    setIsAuthenticated(false);
  };

  // (Optional) เพิ่มตัวจับเวลา: เช็ค Session ทุกๆ 1 นาที เผื่อเปิดหน้าจอค้างไว้นาน
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isSessionValid() && isAuthenticated) {
        alert("Session expired. Please login again.");
        handleLogout();
      }
    }, 60000); // 60,000 ms = 1 นาที

    return () => clearInterval(interval);
  }, [isAuthenticated]);

  return (
    <HashRouter>
      <Routes>
        <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />

        <Route
          path="*"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <MainLayout onLogout={handleLogout}>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/map" element={<ExpressWayMap />} />
                  <Route path="/rsu" element={<RSUManagement />} />
                  <Route path="/obu" element={<OBUManagement />} />
                  <Route path="/event" element={<EventLog />} />
                </Routes>
              </MainLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </HashRouter>
  );
}

export default App;